import { IWidgetInstance } from './widget-renderer.header';

export function getIframeIdFromEvent(mouseEvent: MouseEvent): string | undefined {
    const currentTarget = mouseEvent.currentTarget;
    if (!currentTarget) {
        return;
    }
    if ((currentTarget as Document).defaultView) {
        return (currentTarget as Document).defaultView?.frameElement?.id;
    }
    return (currentTarget as HTMLElement)?.ownerDocument?.defaultView?.frameElement?.id;
}

export function translateOpenEventPosition(
    mouseEvent: MouseEvent,
    widgetInstance: IWidgetInstance | undefined
): { x: number; y: number } {
    if (!widgetInstance?.instance) {
        return {
            x: mouseEvent.clientX,
            y: mouseEvent.clientY
        };
    }

    const { x: widgetX, y: widgetY } = widgetInstance.instance;
    // mouseEvent.clientX and clientY values are relative to the iframe
    return {
        x: mouseEvent.clientX + widgetX,
        y: mouseEvent.clientY + widgetY
    };
}
